import { useTranslation } from '@lichtblick/i18next';

import { Container } from './FloatingMessageCard.styles';

import { ChatAvatar } from '../ChatAvatar';
import { FieldSection, FieldSectionProps } from '../ChatInput/partials/FieldSection';
import { Foldout } from '../Foldout';

export const FloatingMessageCard = (props: FieldSectionProps) => {
  const { t } = useTranslation('common');

  return (
    <Foldout
      hasFlippedArrow
      icon={<ChatAvatar isCraftsman={false} />}
      isOpen={true}
      size="small"
      title={t('details.you')}
    >
      <Container>
        <FieldSection {...props} />
      </Container>
    </Foldout>
  );
};
